import React from 'react'
import Layout from '../Layout/Layout'

const PrivacyPolicy = () => {
  return (
    <Layout>
    <div
        className='mx-auto min-h-screen px-10'
        style={{
          background: 'linear-gradient(to bottom, #141335, #0c0d1a)', // Gradient background applied here
        }}
      >Privacy Policy</div>
    </Layout>
  )
}

export default PrivacyPolicy